/**
 * parser class
 * @static
 */
export default class MenuTreeParser {
  /**
   * traverses the node
   * @param node
   * @param searched
   * @param acc
   * @return {*}
   */
  static traverseNode(node = {}, searched = '', acc = []) {
    acc.push(node)
    if (node.path === searched) {
      return acc
    }

    if (node.isParent) {
      for (let i = 0; i < node.children.length; i++) {
        const res = MenuTreeParser.traverseNode(node.children[i], searched, acc)
        if (res) {
          return res
        }
      }
    } else {
      acc.pop()
    }
    return null
  }

  /**
   * parses the tree
   * @param nodes
   * @param path
   * @param acc
   * @return {*}
   */
  static parse(nodes = [], path = '', acc = []) {
    for (let i = 0; i < nodes.length; i++) {
      const result = MenuTreeParser.traverseNode(nodes[i], path, acc)
      if (result) {
        return result
      }
      acc = []
    }
  }
}
